import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateDossierStatusController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierStatusController.php
* @route '/api/dossier/{dossier}/status'
*/
const UpdateDossierStatusController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierStatusController.url(args, options),
    method: 'put',
})

UpdateDossierStatusController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/status',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierStatusController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierStatusController.php
* @route '/api/dossier/{dossier}/status'
*/
UpdateDossierStatusController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierStatusController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierStatusController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierStatusController.php
* @route '/api/dossier/{dossier}/status'
*/
UpdateDossierStatusController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierStatusController.url(args, options),
    method: 'put',
})

export default UpdateDossierStatusController